<!-- src/components/nursingHome/NursingHomeCard.vue -->
<template>
  <div class="nursing_home_card">
    <div class="lft_img">
      <img :src="require('@/assets/' + imageUrl + '.jpg')" alt="养老院环境" />
    </div>
    <div class="rht_content">
      <div class="rht_title">
        <span>{{ title }}</span>
      </div>
      <div class="rht_text">{{ description }}</div>

      <div class="info_list">
        <div class="info_item">
          <img src="../../assets/icon_room.png" alt="房型" />
          <span>房型：{{ roomTypes }}</span>
        </div>
        <div class="info_item">
          <img src="../../assets/icon_bed.png" alt="床位" />
          <span>床位：{{ beds }}张</span>
        </div>
        <div class="info_item">
          <img src="../../assets/icon_location.png" alt="地址" />
          <span>地址：{{ address }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NursingHomeCard',
  props: {
    title: String,
    description: String,
    imageUrl: String,
    roomTypes: String,
    beds: String,
    address: String
  }
}
</script>

<style scoped lang="scss">
.nursing_home_card {
  width: 80vw;
  height: 36vh;
  display: flex;
  margin: 0 auto;
  overflow: hidden;

  .lft_img {
    flex: 1;
    border-radius: 10px;
    overflow: hidden;

    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
      transition: all 0.5s;

      &:hover {
        transform: scale(1.1);
      }
    }
  }

  .rht_content {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 0 5rem;
    justify-content: space-around;
    align-items: center;

    .rht_title {
      margin-top: 4rem;
      width: 100%;
      height: 20%;
      font-size: 1.8rem;
      color: #444444;
      padding-bottom: 0.8rem;
      display: flex;
      align-items: center;
      justify-content: flex-start;

      span {
        line-height: 100%;
      }
    }

    .rht_text {
      margin: 2rem 0 2.5rem;
      color: #666666;
      font-size: 1.2rem;
      text-align: left;
      width: 100%;
      line-height: 1.6;
    }

    .info_list {
      width: 100%;
      margin: 1rem 0;
      display: flex;
      flex-direction: column;
      gap: 0.8rem;
      font-size: 1.1rem;
      color: #333;

      .info_item {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        margin-bottom: 1rem;

        img {
          width: 1.4rem;
        }
      }
    }

    .btn {
      border-radius: 0.5rem;
      font-size: 1.4rem;
      border: none;
      width: 12.2rem;
      line-height: 3.2rem;
      background-color: #ff7000;
      border: solid 0.01rem #ff7000;
      color: white;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        background-color: #e66d00;
      }
    }
  }
}
</style>